<template>
    <zen-message-modal
        :isOpen="isOpen"
        @close="$emit('close')"
        title="Remove Project"
    >
        <template #icon>
            <zen-icon-remove />
        </template>
        <template #body>
            <div class="space-y-3">
                <p class="text-sm text-taupe-700">
                    This action <span class="font-medium">cannot</span> be
                    undone. Removing a project will permanently delete:
                </p>
                <ul
                    class="list-disc list-inside space-y-1 text-sm text-taupe-700 ml-2"
                >
                    <li>All environments</li>
                    <li>All feature flags</li>
                    <li>All associated data</li>
                </ul>
                <p class="text-sm font-medium text-red-600">
                    Please be certain before proceeding.
                </p>
            </div>
        </template>
        <template #buttons>
            <zen-button @click="$emit('close')" variant="secondary">
                Close
            </zen-button>
            <zen-button
                @click="$emit('confirm')"
                variant="primary-danger"
                :processing="processing"
            >
                Remove
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script setup>
defineProps({
    isOpen: {
        type: Boolean,
        required: true,
    },
    processing: {
        type: Boolean,
        default: false,
    },
})

defineEmits(['close', 'confirm'])
</script>
